<template>
    <div>
        <router-link class="wrap-item-exercise"
            :to="{ path: getPath, query: { id: item.id, classSchoolId: this.$route.query.id, className: className } }"
            target="_blank">
            <div class="header-item-exercise" :title="item.name">
                <strong class="b-ellipsis">{{ item.name }}</strong>
            </div>
            <div class="footer-item-exercise">
                <div v-if="type == 3"><strong>{{ item.typeExcerciseName }}</strong></div>
                <div v-if="type == 3 && item.typeExcercise == 1"><strong>Thời gian: {{
                    formatTime(item.minuteExcercise) }}</strong></div>
                <div v-if="type == 3 && item.typeExcercise == 2"><strong>&nbsp;</strong></div>
                <div class="timeAssignEnd">
                    <strong>Thời hạn: {{ moment(item.timeAssignEnd).format(formatDate) }}</strong>
                </div>
                <div class="status">
                    <strong>{{ textStatus }}</strong>
                </div>
                <div v-if="status == 2">
                    <strong>
                        Tiến độ: {{ formatNumber(this.completeRate) }}%
                    </strong>
                </div>
                <div v-if="status == 3 && type == 3">
                    <strong class="text-success">
                        Điểm: {{ formatNumber(item.point) }}
                    </strong>
                </div>
                <div v-if="status == 3">
                    <strong>
                        Thời gian hoàn thành: {{ moment(item.completeDate).format(formatDate) }}
                    </strong>
                </div>
            </div>
        </router-link>

    </div>
</template>
<script>
import moment from "moment";
import { PLANING_LESSON_WAREHOUSE, PLANING_LESSON_ASSIGN, ELECTRONIC_LECTURE_WAREHOUSE, ELECTRONIC_LECTURE_ASSIGN } from './../constants/constants_enum'
export default {
    data() {
        return {
            formatDate: "HH:mm - DD/MM/YYYY",
            statusEnum: {
                '1': 'Bài mới',

            },
            completeRate: 0,
            PLANING_LESSON_WAREHOUSE, PLANING_LESSON_ASSIGN, ELECTRONIC_LECTURE_WAREHOUSE, ELECTRONIC_LECTURE_ASSIGN
        }
    },
    props: {
        item: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        },
        status: {
            type: Number,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: 0
        },
        type: {
            type: Number,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: 0
        },
        className: {
            type: String,
            default: ''
        }
    },
    watch: {
        'item.id': 'getValueCompleteRate'
    },
    computed: {

        textStatus() {
            return this.statusEnum[`${this.status}`]
        },
        getPath() {
            if (this.type == ELECTRONIC_LECTURE_WAREHOUSE) {
                return '/bai-giang-dien-tu/thong-tin-bai-giang'
            }
            else if (this.type == PLANING_LESSON_WAREHOUSE) {
                return '/ke-hoach-bai-day/thong-tin-bai-day'
            }
            return '/lam-de-kiem-tra'
        }
    },
    mounted() {
        console.log(this.type)
        this.getValueCompleteRate()
    },
    methods: {
        moment,
        formatTime(seconds) {
            if (seconds) {
                seconds = seconds * 60
            }
            let hours = Math.floor(seconds / 3600); // Số giờ
            let minutes = Math.floor((seconds % 3600) / 60); // Số phút

            if (hours === 0) {
                return minutes + " phút";
            }

            return hours + " giờ " + minutes + " phút";
        },
        formatNumber(value) {
            if (typeof value !== 'number') {
                let valueParse = parseFloat(value);
                if (isNaN(valueParse)) {
                    return value;
                }
                return valueParse.toFixed(2);
            }
            if (value % 1 == 0.5) {
                return value.toFixed(1);
            }
            return value.toFixed(0);

        },
        getValueCompleteRate() {
            if (this.status == 2 && this.type == 3) {
                this.completeRate = ((this.item.countAnswer || 0) / (this.item.countQuestion || 1) * 100).toFixed(0)
            }
            else {
                this.completeRate = this.item.completeRate
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.wrap-item-exercise {
    color: black;
    margin-top: 10px;
    border-radius: 15px;
    min-height: 10rem;
    border: 1px solid #dfdfdf;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.header-item-exercise {
    padding: 0.8rem 1rem;
    border-bottom: 1px solid #dfdfdf;
    background-color: #0f3dba;
    border-radius: 15px 15px 0px 0px;
    color: white;
}

.footer-item-exercise {
    padding: 10px;
}
</style>